/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import ContentArea from '@components/Layout/ContentArea';
import StructuredTextContent from '@components/UI/StructuredTextContent';

/**
 * Render SP Banner Component
 * @param {Object} sectionContent - data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns {ReactElement} - SP Banner Component
 */
export default function SPBanner({ sectionContent, region, lang }) {
  const secCon = sectionContent.sectionContent;
  return (
    <>
      {secCon[5] &&
        secCon[5].body?.value?.document?.children[0]?.children[0]?.value !=
          '' && (
          <Box
            bg="#ffd477"
            height="66px"
            color="#000"
            px="8%"
            py="18px"
            fontSize={{ base: '14px', lg: '18px' }}
            fontFamily="FedraSansStd-book"
            display="block"
            className="information_strip"
          >
            {StructuredTextContent(secCon[5]?.body)}
          </Box>
        )}
      <Box
        pos="relative"
        w="100%"
        height={{ base: '600px', md: '600px' }}
        borderWidth="0"
        maxWidth="1300px"
        margin="0 auto"
        zIndex="0"
      >
        <Box
          display="flex"
          w="100%"
          flexDirection={{
            md: 'row',
            base: 'column',
          }}
          height={{
            md: '600px',
            base: 'auto',
          }}
          pos="relative"
          className="bg-banner"
        >
          <Box
            // float="left"
            position={{
              md: 'relative',
              lg: 'relative',
              base: 'absolute',
              sm: 'absolute',
            }}
            bottom={{ base: '-818px', sm: '-725px', md: '0', lg: '0' }}
            h={{ lg: '', md: '' }}
            marginLeft="auto"
          >
            <video autoplay="true" id="player" loop muted playsinline>
              <source
                // src={`${config.imgPath}/d/46272/1663674805-sp_header_vid.mp4`}
                src={secCon[4]?.embedUrl}
              ></source>
            </video>
          </Box>
        </Box>
        <Box
          w={{ lg: '60%', base: '100%' }}
          left="0"
          pos="absolute"
          top={{ base: '49px', md: '50px', lg: '70px' }}
          zIndex="3"
          p={{ base: '0 20px', md: '0 80px' }}
        >
          <Box w={{ md: '100%', base: '100%' }}>
            <Text
              as="h1"
              fontFamily={
                lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-A-medium'
              }
              fontWeight="normal"
              color="#ffffff"
              fontSize={{ base: '30px', md: '60px' }}
              lineHeight={{ base: '1.11', lg: '48px' }}
            >
              {secCon[0]?.text}
            </Text>
            <Text
              w="100%"
              textAlign="left"
              fontFamily={
                lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-A-medium'
              }
              fontWeight={lang === 'ta' ? 'bold' : '500'}
              lineHeight="1"
              color="#fff"
              mb={'20px'}
              mt={'20px'}
              fontSize={{
                base: lang === 'ta' ? '18px' : '20px',
                md: '35px',
                lg: lang === 'ta' ? '32px' : '45px',
              }}
            >
              {secCon[1]?.text}
            </Text>
            <Text
              className="bannertext"
              width={{ base: lang === 'ta' ? '98%' : '90%', md: '100%' }}
            >
              <ContentArea
                font={{ base: '14px', md: lang === 'ta' ? '14px' : '18px' }}
                mainContent={secCon[2].body}
                region={region}
                m={'0 !important'}
                p="0 !important"
                px="0"
                mx="0 !important"
                fontSize={{ base: '14px', md: '18px' }}
                lang={lang}
                pb={{ base: '0', md: '30px' }}
                color="#ffffff"
              />
            </Text>
            <SimpleButton
              style={secCon[3]}
              region={region}
              lang={lang}
              textAlign="center"
              fontstyle={lang === 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'}
              fontbold={lang === 'ta' ? 'bold' : 'normal'}
            />
          </Box>
        </Box>
      </Box>
      <style global jsx>{`
        .bannertext p {
          color: #ffffff !important;
          line-height: 27px;
          font-family: 'FedraSansStd-book';
          text-align: left;
        }
        .bannertext div {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
        #player {
          height: 600px;
        }
        .information_strip a {
          color: #cf4520;
        }
        /* smaller devices (mobile, 767px and up) */
        @media only screen and (max-width: 767px) {
          .bannertext p {
            line-height: 26px;
          }
          .bg-banner::before {
            content: '""';
            width: 100%;
            height: 550px;
            background: linear-gradient(
              to bottom,
              #571211 0%,
              #611413 67%,
              rgba(255, 175, 75, 0) 100%
            );
            position: absolute;
            z-index: 1;
            left: 0;
          }
          .bannertext strong {
            font-weight: normal !important;
          }
        }

        /* Large devices (laptops/desktops, tablets 768px and up) */
        @media only screen and (min-width: 768px) {
          .bg-banner::before {
            content: '""';
            width: 100%;
            height: 600px;
            background: linear-gradient(
              to right,
              #571211 0%,
              #611413 50%,
              rgba(255, 175, 75, 0) 100%
            );
            position: absolute;
            z-index: 1;
            left: 0;
          }
          #player {
            height: 600px;
            width: auto;
          }
        }
      `}</style>
    </>
  );
}
